import moment from "moment";

export const parseAndFormatDate = (timestamp: string) => {
  const readableDate = moment(timestamp).format("MMMM Do YYYY, h:mm:ss A");
  return readableDate;
};
